import { GetClientFlags200Response } from "@coeff/api";
import { StatsigProvider, useClientBootstrapInit } from "@statsig/react-bindings";
import { StatsigUser } from "@statsig/react-bindings";
import React from "react";

import { BuildFlags, EventProperties } from "../types";

type Props = {
  children: React.ReactNode;
  eventProps: EventProperties;
  clientFlags: GetClientFlags200Response | undefined;
};

export const StatsigSynchronousProvider: React.FC<Props> = ({
  children,
  clientFlags,
  eventProps,
}) => {
  const initializeValues = clientFlags?.statsig_client_bootstrap_values ?? {};

  const userID = eventProps.user_id || eventProps.email;

  const user: StatsigUser = {
    userID,
    email: eventProps.email,
    custom: {
      ...clientFlags?.statsig_user_custom_attributes,
      domain: eventProps.domain,
    },
    // Pass the domain as a customID so gates whose Statsig Unit Type is `domainID`
    // (e.g. the enable_excel_sheets_assistant phased rollout) bucket by domain and
    // line up with the bootstrap values computed on the backend, which passes the
    // same customID. Must match DOMAIN_CUSTOM_ID_TYPE in the server's statsig_utils.
    ...(eventProps.domain ? { customIDs: { domainID: eventProps.domain } } : {}),
  };

  const client = useClientBootstrapInit(
    BuildFlags.statsig_client_key,
    user,
    JSON.stringify(initializeValues),
    {
      environment: { tier: COEFF_ENV },
    }
  );

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};
